/* unplugin-vue-components disabled */import { render } from "./playerDetail.vue?vue&type=template&id=8c6d85c0&scoped=true&ts=true"
import script from "./playerDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./playerDetail.vue?vue&type=script&lang=ts&setup=true"

import "./playerDetail.vue?vue&type=style&index=0&id=8c6d85c0&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6d85c0"],['__file',"src/components/player/playerDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c6d85c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c6d85c0', __exports__)) {
    console.log('reload')
    api.reload('8c6d85c0', __exports__)
  }
  
  module.hot.accept("./playerDetail.vue?vue&type=template&id=8c6d85c0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8c6d85c0', render)
  })

}


export default __exports__